import Image from 'next/image'
import { ButtonLink } from '@components/ui/Button'
import styles from './styles.module.scss'
import { FIT_FINDER_HASH } from '@consts/index'

export function NoSavedFitContent() {
  return (
    <div className={styles.FitGrid__noSavedFit_content}>
      <Image
        src="/static/images/account/fit-finder-clock-white-bg.gif"
        alt="Fit Finder"
        width={600}
        height={764}
        unoptimized
      />
      <p>Discover your perfect size in 60 seconds.</p>
      <p>
        We ask a few simple questions, crunch the numbers and recommend a size.
        It's science.
      </p>
    </div>
  )
}

export default function NoSavedFit() {
  return (
    <div className={styles.FitGrid}>
      <div className={styles.FitGrid__noSavedFit}>
        <NoSavedFitContent />
      </div>
      <div className={styles.FitGrid__fitFinder}>
        <ButtonLink
          href={`#${FIT_FINDER_HASH}`}
          rawHref={true}
          variant="white"
          fullWidth="always"
        >
          Take the Fit Finder
        </ButtonLink>
      </div>
    </div>
  )
}
